import type { ComponentProps } from 'react'

import { styled, Checkbox as MuiCheckbox, checkboxClasses } from '@mui/material'

const StyledCheckbox = styled(MuiCheckbox)(({ theme }) => ({
  paddingRight: 0,
  marginRight: theme.spacing(2),
  width: theme.spacing(3),
  height: theme.spacing(3),

  [`&.${checkboxClasses.root}`]: {
    paddingRight: 0,

    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
}))

export const Checkbox = (props: ComponentProps<typeof MuiCheckbox>) => {
  const { color = 'primary', disableRipple = true, ...rest } = props

  return <StyledCheckbox color={color} disableRipple={disableRipple} {...rest} />
}
